module.exports = __webpack_public_path__ + "img/people.f98dcf32.png";